import { ProcessingNode } from '@openhps/core';
export class ImageProcessingNode extends ProcessingNode {
    constructor(options) {
        super(options);
    }
    process(frame) {
        return new Promise((resolve, reject) => {
            if (frame.image) {
                this.processImage(frame.image, frame)
                    .then((image) => {
                    frame.image = image;
                    resolve(frame);
                })
                    .catch(reject);
            }
            else {
                resolve(frame);
            }
        });
    }
}
//# sourceMappingURL=ImageProcessingNode.js.map